module.exports = __webpack_public_path__ + "static/media/wrl3.png.afd616bc.jpg";